/**
 * The two ways a violation reaches a facility. Mirrors the join each harmonize
 * stage actually performs, which is why the review record is keyed on this
 * rather than on the alternate-id type: the waste stage collapses 'EPA' and
 * 'RCRAINFO' into one match group, so keying on type would produce two
 * candidate records for a single violation.
 *
 * Lives here rather than in the harmonize task because both sides of the review
 * gate need it — the task writes the records, and the staff queue reads back the
 * alternate-id rows behind each one.
 *
 * Deliberately a sibling module with no barrel export, for the same reason as
 * `visibleHarmonizedViolationWhere`.
 */
export type ExpiredAltIdMatchKindLiteral = "WASTE_HANDLER" | "FRS_REGISTRY";

/**
 * The `FacilityAlternateId.type` values a match kind can resolve through.
 *
 * FRS_REGISTRY covers water AND air: both match an FRS-typed value against
 * `registryId`, so one record — and one acceptance — releases both programs'
 * rows for that facility. That is a property of how EPA identifies facilities,
 * not a simplification made here.
 */
export function altIdTypesFor(kind: ExpiredAltIdMatchKindLiteral): string[] {
  return kind === "WASTE_HANDLER" ? ["RCRAINFO", "EPA"] : ["FRS"];
}

/**
 * `extensions.code` on the refusal thrown when a save would un-expire an
 * alternate id whose violations are held for staff review.
 *
 * Shared because both sides need it: the API stamps it on the error, and Oak
 * keeps that refusal on screen instead of letting it auto-dismiss — it names a
 * remedy the reader has to act on.
 */
export const HELD_ALTERNATE_ID_ERROR_CODE = "HELD_EXPIRED_ALT_ID";
